export const serviceGetWay = {
    qms:'/create-service', //问卷相关接口
    data:'/data-service', //数据相关接口
    ueser:'/system-service', //用户相关接口
}


// WEBPACK FOOTER //
// ./src/getWay/index.js